import gql from "graphql-tag";

export const VIEW_ROLE = gql`
query viewRole($userId: uuid!){
    users(where: {id: {_eq: $userId}}){
      role
    }
  }
`;
